import * as PropTypes from "prop-types";
import React from "react";
import {connect} from "react-redux";
import {Link, Redirect, Route, Switch, withRouter} from "react-router-dom";
import AuthContainer from "./AuthContainer";
import SecureRoute from "./common/SecureRoute";
import "../styles/_site.scss";
import {setSelectedMenuItem, getMenuNotifications} from "../actions/menu/menuAction";
import {TopLevelMenuItemModel} from "../models/menuItemModel";
import TopBar from "./TopBar";
import {setTopRailNavigation} from "../actions/nav/topRailNavAction";
import {LoadingPanel} from "Ncontracts.Common.UI";
import _ from "lodash";
import addTracking from "../helpers/addTracking";
import {CurrentUser} from "../services/CurrentUser";
import {startSession} from "../actions/user/platformUserAction";
import permissionService from "../services/PermissionService";
import {imageCdnUrls} from "../configs/app/imageCdnUrls";

class Home extends React.Component {

    static propTypes = {
        setSelectedMenu: PropTypes.func,
        menuItems: PropTypes.arrayOf(PropTypes.shape(TopLevelMenuItemModel)),
        location: PropTypes.object,
        setSelectedTopRailNav: PropTypes.func,
        getMenuNotifications: PropTypes.func,
        user: PropTypes.object,
        startSession: PropTypes.func,
        history: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        addTracking();
        window.addEventListener("resize", this.handleWindowResize);
        this.props.getMenuNotifications();
        this.trySetSelectedItemFromRoute();
        this.init();
        this.quitListening = this.props.history.listen(() => {
            const mainContent = document.getElementsByClassName('main-content');
            if (mainContent && mainContent[0]) {
                mainContent[0].scrollTop = 0;
            }
        });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", null);
        this.quitListening();
    }

    init = () => {
        if (CurrentUser.isValid()) {
            this.props.startSession();
        }
    };

    trySetSelectedItemFromRoute = () => {
        const {location, menuItems} = this.props;

        if (location !== undefined) {
            const currentPath = location.pathname
                                        .split('/')
                                        .filter(result => result !== undefined && result.trim().length > 0);

            if (currentPath.length > 0) {
                const path = `/${currentPath[0]}`;
                let menuId = undefined;
                for(let i = 0;i<menuItems.length;i++) {
                    if (menuItems[i].path === path) {
                        menuId = menuItems[i].id;
                        break;
                    }else if (menuItems[i].menus !== undefined && menuItems[i].menus.length > 0) {
                        const subMenuItem = menuItems[i].menus.find(x => x.path === path);
                        if (subMenuItem !== undefined) {
                            menuId = subMenuItem.id;
                            break;
                        }
                    }
                }

                if (menuId !== undefined) {
                    this.props.setSelectedMenu(menuId);
                }
            }
        }
    };

    handleWindowResize = () => {
        const theHeight = window.innerHeight > document.getElementsByClassName("main-content")[0].clientHeight
                    ? window.innerHeight
                    : document.getElementsByClassName("main-content")[0].clientHeight;

        document.getElementsByClassName("side-panel-menu")[0].style.height = `${theHeight}px`;
    };

    handleItemClicked = menuId => {
        this.props.setSelectedMenu(menuId);
        this.props.setSelectedTopRailNav(menuId);
    };

    renderTopLevelMenuItem = (menuItem) => {
        const selectedClass =
            (menuItem.selected === true)
                ? (menuItem.menus !== undefined && menuItem.menus.length > 0)
                    ? "child-selected"
                    : "selected-link"
                : "";

        return (menuItem.path === undefined || menuItem.path === "/")
                ? (<li onClick={() => this.handleItemClicked(menuItem.id)} className={selectedClass}>
                            <div>{menuItem.display}{menuItem.showIndicator && <span className="red-dot-notification" />}</div>
                    </li>)
                : (<Link to={menuItem.path}
                         onClick={() => this.handleItemClicked(menuItem.id)}>
                        <li className={selectedClass}>
                            <div>{menuItem.display}{menuItem.showIndicator && <span className="red-dot-notification" />}</div>
                        </li>
                   </Link>);

    };

    renderSubMenuItems = (menuItem) => {
        if (menuItem.expanded === true && menuItem.menus.length > 0) {
            const subLevel = menuItem.menus.map(subMenu => {
                const selectedCss = subMenu.selected === true ? "selected-link" : "";
                return(subMenu.path === undefined || subMenu.path === "/")
                    ? (<li key={subMenu.id}
                           onClick={() => this.handleItemClicked(subMenu.id)}
                           className={selectedCss}>
                            <div>{subMenu.display}{subMenu.showIndicator && <span className="red-dot-notification" />}</div>
                    </li>)
                    : (<Link to={subMenu.path}
                             key={subMenu.id}
                             onClick={() => this.handleItemClicked(subMenu.id)}>
                        <li className={selectedCss}>
                            <div>{subMenu.display}{subMenu.showIndicator && <span className="red-dot-notification" />}</div>
                        </li>
                    </Link>);
            });

            return (<ul className="sub-menu-item">{subLevel}</ul>);
        }

        return "";
    };

    buildRoutes = () => {
        return this.props.menuItems.map((menuItem,index) => {

            let allRoutes = [];

            menuItem.menus.forEach(sub => {
                if (sub.path !== undefined && sub.path !== "/") {
                    if (sub.isSecured) {
                        allRoutes.push (<SecureRoute
                            key={index}
                            path={sub.path}
                            exact={sub.exact}
                            component={sub.componentToRender} />);
                    } else {
                        allRoutes.push (<Route
                            key={index}
                            path={sub.path}
                            exact={sub.exact}
                            component={sub.componentToRender} />);
                    }
                }
            });

            if (menuItem.componentToRender !== undefined && menuItem.path !== undefined && menuItem.path !== "/") {
                if (menuItem.isSecured) {
                    allRoutes.push(<SecureRoute
                        key={menuItem.display}
                        path={menuItem.path}
                        exact={menuItem.exact}
                        component={menuItem.componentToRender} />);
                }
                else {
                    allRoutes.push(<Route
                        key={menuItem.display}
                        path={menuItem.path}
                        exact={menuItem.exact}
                        component={menuItem.componentToRender} />);
                }
            }

            return allRoutes;
        });
    };

    findHomePage = () => {
        if (this.props.user === undefined) {
            return "/assignments";
        }

        return permissionService.getStartPage();
    };

    render() {
        const loader = (_.isUndefined(this.props.user)) ?
            <div style={{height: "100vh", width: "100vw", background: "#f2f2f2", zIndex: 99999999, position: "absolute"}}>
                <LoadingPanel config={{active: true}} />
            </div>
            : undefined;

        let selectedLeftNav = 'none';

        const menuDisplay = this.props.menuItems.map(m => {
            if (m.selected) selectedLeftNav = m.id;

            const sub = this.renderSubMenuItems(m);
            const top = this.renderTopLevelMenuItem(m);

            return (
                <div key={m.id}>
                    <ul>{top}</ul>
                    {sub}
                </div>);
        });

        const mainContentClassName = selectedLeftNav.toLowerCase() === 'training' ? 'main-content no-scroll' : 'main-content';

        return (
            <Switch>
                <Route render={() => {

                    return <React.Fragment>

                        {loader}

                        <div className="home-page">
                            <div className="side-panel-menu">
                                <div className="company-logo-section">
                                    <img className="hp__enterprise-logo"
                                         src={`${imageCdnUrls.enterpriseLogo}`}
                                         alt="Enterprise"/>
                                </div>
                                {menuDisplay}
                            </div>
                            <div className="content-panel">
                                <nav className="navbar navbar-main navbar-fixed-top">
                                    <TopBar/>
                                </nav>
                                <div className={mainContentClassName}>
                                    <Switch>
                                        <Route path="/redirect/:nonce" component={AuthContainer} />
                                        {this.buildRoutes()}
                                        <Redirect from="/" to={this.findHomePage()}/>
                                    </Switch>
                                </div>
                            </div>
                        </div>

                    </React.Fragment>;
                }
                }/>
            </Switch>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setSelectedMenu: (menuId) => dispatch(setSelectedMenuItem(menuId)),
        setSelectedTopRailNav: (menuId) => dispatch(setTopRailNavigation(menuId)),
        getMenuNotifications: () => dispatch(getMenuNotifications()),
        startSession: () => dispatch(startSession())
    };
}

function mapStateToProps(state) {
    return {
        menuItems: state.menu.items,
        user: state.platformUser.user
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));

